import { getKeyPowerGameMessage } from "../constants/keys";
import "./GameKeyPowerBar.css";

export default function GameKeyPowerBar({ activeKeyId }) {
  const message = getKeyPowerGameMessage(activeKeyId);
  if (!message) return null;

  return (
    <div className="game-key-power-bar" role="status">
      {message}
    </div>
  );
}
